import React, { useRef, useState } from 'react';
import { Category } from 'shared/types/product/Category';
import HeaderNavigationButtonDesktop from 'components/commercetools-ui/organisms/header/header-navigation/header-navigation-desktop/header-navigation-button';
import { Tile } from 'components/commercetools-ui/organisms/header/types';
import useClassNames from 'helpers/hooks/useClassNames';
import useScrollDirection from 'helpers/hooks/useScrollDirection';
import MenuDropdown from './menu-dropdown';
import dynamic from 'next/dynamic';

import { XMarkIcon as CloseIcon, XMarkIcon, MagnifyingGlassIcon } from '@heroicons/react/24/solid';
const AlgoliaSearch = dynamic(() => import('components/commercetools-ui/atoms/search-algolia'));

export interface Props {
  links: any[];
  tiles: Tile[];
  showSearchBar?: boolean;
  categories: Category[];
  setShowSearchBar?: any;
}

const HeaderNavigationDesktop: React.FC<Props> = ({ links, tiles, showSearchBar, categories, setShowSearchBar }) => {
  const [activeCategory, setActiveCategory] = useState<any>();
  const tileContent = tiles.filter((tile) => tile.tileCategory === activeCategory?.name);

  const showSubMenu = (category?: Category) => {
    setActiveCategory(category);
  };
  const hideSubMenu = () => {
    setActiveCategory(undefined);
  };

  const showTimeout = useRef<NodeJS.Timeout | null>(null) as React.MutableRefObject<NodeJS.Timeout | null>;

  const clearShowTimeout = () => {
    if (showTimeout.current) {
      clearTimeout(showTimeout.current);
      showTimeout.current = null;
    }
  };

  const handleMouseIn = (category: Category) => {
    clearShowTimeout();
    if (activeCategory) showSubMenu(category); //Already opened do not delay
    else showTimeout.current = setTimeout(() => showSubMenu(category), 150);
  };
  const handleMouseClick = (category: any) => {
    clearShowTimeout();
    if (activeCategory) showSubMenu(category); //Already opened do not delay
    else showTimeout.current = setTimeout(() => showSubMenu(category), 50);
    if (category?.label === activeCategory?.label) hideSubMenu();
  };

  const handleMouseOut = () => {
    clearShowTimeout();
    hideSubMenu();
  };

  const scrollDirection = useScrollDirection(5, -1);
  const navigationClassNames = useClassNames([
    'hidden items-center lg:flex duration-150 transition-all pl-44 xl:pl-50 2xl:pl-70 w-fit',
    showSearchBar && 'pb-[4rem] 2xl:pb-[6rem]',
    // scrollDirection === 'down' ? 'h-0 opacity-0 pointer-events-none' : 'h-52 opacity-1 pointer-events-auto',
  ]);
  
  return (
    <div onMouseLeave={handleMouseOut}>
      {links && (
        <>
          <div className={navigationClassNames}>
            <div className="flex w-fit justify-start gap-10">
              {links.map((link) => (
                <div key={link?.label} onClick={() => handleMouseClick(link)} onMouseEnter={() => handleMouseIn(link)}>
                  <HeaderNavigationButtonDesktop
                    show={link.label === activeCategory?.label}
                    link={link}
                    updateSubMenu={hideSubMenu}
                  />
                </div>
              ))}
            </div>
            <MenuDropdown
              show={
                !!activeCategory && !!activeCategory?.mega_menu && activeCategory?.mega_menu.submenu_links?.length > 0
              }
              onClick={hideSubMenu}
              links={activeCategory?.mega_menu?.submenu_links ?? []}
              tileContent={tileContent[0]}
            />
          </div>
          
            <div className={`${showSearchBar ?"lg:block":""} absolute top-[6.25rem] z-[1000] hidden w-screen bg-white md:px-24 md:py-12  3xl:top-[9rem] 2xl:px-48`}>
              <AlgoliaSearch categories={categories} showSearchBar={showSearchBar} setShowSearchBar={setShowSearchBar}/>
              <XMarkIcon
                className="absolute right-[1rem] top-1/2 z-[999] !h-24 !w-24 -translate-y-1/2 stroke-2 text-primary-black hover:cursor-pointer lg:right-[5.5rem]"
                onClick={() => setShowSearchBar(false)}
              />
              <MagnifyingGlassIcon
                className="stroke-10 absolute left-[1rem] top-1/2 z-[999] h-24 w-24 -translate-y-1/2 text-[#666] lg:hidden"
                onClick={() => setShowSearchBar(false)}
              />
            </div>
          
        </>
      )}
    </div>
  );
};

export default HeaderNavigationDesktop;
